// extracted by mini-css-extract-plugin
export default {"message":"DeleteConfirmModal_message__5lXI3","footer":"DeleteConfirmModal_footer__iKBBw","cancel":"DeleteConfirmModal_cancel__OD-kW","confirm":"DeleteConfirmModal_confirm__RWMCb"};